export const MAIN_URL = "https://api.froomie.io/";
export const IMAGE_BASE_URL = "https://api.froomie.io/";
//export const MAIN_URL = "http://localhost:8000/";
//export const IMAGE_BASE_URL = "http://localhost:8000/";
export const API_VERSION = "api/v1";
export const BASE_URL = `${MAIN_URL}${API_VERSION}`;
export const MAP_KEY = "AIzaSyATRNKsl5qXmqqia8ylr5aBgE1RxVdsl3w";
